import { Box, CssBaseline } from '@mui/material';
import { ThemeProvider } from '@mui/material/styles';
import Cookies from 'js-cookie';
import { HelmetProvider } from 'react-helmet-async';
import { Navigate, Outlet, Route, BrowserRouter as Router, Routes } from 'react-router-dom';
import './styles/scrollbar.css';

import Sidebar from './components/Sidebar';
// import TopNavbar from './components/TopNavbar';
import AddAdmin from './pages/Addadmin';
import BlogChecklist from './pages/BlogChecklist';
import Contacts from './pages/Contacts';
import ContentTracking from './pages/ContentTracking';
import Cryptorank from './pages/Cryptorank';
import Dashboard from './pages/Dashboard';
import LinkedinPostChecklist from './pages/LinkedinPostChecklist';
import Login from './pages/Login';
import TwitterDashboard from './pages/TwitterDashboard';
import darkTheme from './theme/theme';

// Layout component for protected pages
const ProtectedLayout = ({ children }: { children: React.ReactNode }) => (
  <Box
    sx={{
      display: 'flex',
      height: '100vh',
    }}
  >
    <Sidebar />
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'column',
        flex: 1,
        marginTop: '10px', // Account for top navbar height
        overflow: 'auto',
      }}
    >
      {/* <TopNavbar /> */}
      {/* <Box sx={{ flex: 1}}>{children}</Box> */}
      {/* <TopNavbar /> */}
      <Box sx={{ flex: 1 }}>{children}</Box>
    </Box>
  </Box>
);

// Wrapper for protected routes
// Security Note: Authentication is handled via secure HTTP-only cookies with:
// - secure: true (HTTPS only)
// - sameSite: 'strict' (CSRF protection)
// - 12-hour expiration (automatic cleanup)
// - Backend validates tokens on every API request
// Users stay logged in across page refreshes and only logout when:
// 1. They explicitly click logout
// 2. Token expires (12 hours)
// 3. Backend invalidates the token
const ProtectedRoute = () => {
  return Cookies.get('token') ? <Outlet /> : <Navigate to='/login' replace />;
};

function App() {
  // Note: No beforeunload handler for logout
  // This is intentional and follows security best practices:
  // - Cookies automatically expire after 12 hours
  // - Backend validates tokens on each API request
  // - Prevents logout on page refresh (better UX)
  // - Standard behavior for modern web applications
  return (
    <HelmetProvider>
      <ThemeProvider theme={darkTheme}>
        <CssBaseline />

        <Router>
          <Routes>
            <Route path='/' element={<Navigate to='/dashboard' replace />} />
            <Route path='/login' element={<Login />} />

            {/* Group all protected routes inside `ProtectedRoute` */}
            <Route element={<ProtectedRoute />}>
              <Route
                path='/dashboard'
                element={
                  <ProtectedLayout>
                    <Dashboard />
                  </ProtectedLayout>
                }
              />
              <Route
                path='/cryptorank'
                element={
                  <ProtectedLayout>
                    <Cryptorank />
                  </ProtectedLayout>
                }
              />
              <Route
                path='/add-admin'
                element={
                  <ProtectedLayout>
                    <AddAdmin />
                  </ProtectedLayout>
                }
              />
              <Route
                path='/contacts'
                element={
                  <ProtectedLayout>
                    <Contacts />
                  </ProtectedLayout>
                }
              />
              <Route
                path='/twitter-dashboard'
                element={
                  <ProtectedLayout>
                    <TwitterDashboard />
                  </ProtectedLayout>
                }
              />
              <Route
                path='/content-tracking'
                element={
                  <ProtectedLayout>
                    <ContentTracking />
                  </ProtectedLayout>
                }
              />
              <Route
                path='/blog-checklist'
                element={
                  <ProtectedLayout>
                    <BlogChecklist />
                  </ProtectedLayout>
                }
              />
              <Route
                path='/linkedin-post-checklist'
                element={
                  <ProtectedLayout>
                    <LinkedinPostChecklist />
                  </ProtectedLayout>
                }
              />
            </Route>
          </Routes>
        </Router>
      </ThemeProvider>
    </HelmetProvider>
  );
}

export default App;
